import React, { useEffect, useState, useImperativeHandle, useRef } from 'react';
import styles from './index.module.scss';
let savedRange = null;
/**
 * @param defaultValue // 父组件传入的值
 * @param onChange // 修改父组件的值
 * @param smsTemplateCount // 监听这个值，变化的时候生成span标签
 */
const Text = ({clickTag, defaultValue, onChange, cRef, smsTemplateCount, templateId}) => {
  const [initValue,setInitValue] = useState('');
  const myInputRef = useRef(null);
  /**
   * 获取节点
   * @param text
   * @returns {*}
   */
  const getNode= (text)  =>{
    let node = document.createElement('SPAN');
    node.innerText = text;
    node.style = 'cursor:default;-webkit-user-modify:read-only!important;color:#3399FF;';
    return node;
  }

  /**
   * 增加节点
   * @param node
   */
  const insertNode= (node) => {
    savedRange?.deleteContents();
    savedRange?.insertNode(node);
  }

  /**
   * 添加标签
   * @param text
   */
  const addTag = (text) => {
    if(savedRange?.commonAncestorContainer?.parentElement?.id == 'myInput') {
      let node = getNode(text);
      insertNode(node);
      let txt = formatText(savedRange?.commonAncestorContainer.innerText);
      onChange([txt,'']);
    }
  }

  const onKeyUp = (e) =>{
    const txt  = formatText(e.target.innerText);
    onChange([txt,'']);
    e.preventDefault();
  }

  const formatText = (text) =>{
    return text;
  }
  /**
   * @description 把短链接替换成整体
   * @param shortLink 短链接
   * @return 变成整体的短链接
   */
    function replaceShortLink(shortLink) {
      let arr = shortLink.split('z.douyin.com/');
      let end = arr[1].substr(0, 7);
      let link = ` z.douyin.com/${end} `;
      const text = shortLink?.replace(link, word => {
          return getNode(word).outerHTML;
      });
      return text;
  }
  const setDefaultValue = () => {
    let text = defaultValue?.replace(/#[^#]+#/gi, (word) => {
      return getNode(word).outerHTML;
    });
    if(text.includes('z.douyin.com/')) {
      text = replaceShortLink(text)
    }
    setInitValue(text);
  }
  useImperativeHandle(cRef, () => ({
    // changeVal 就是暴露给父组件的方法
    cleanText: (newVal) => {
      setInitValue('');
      document.getElementById('myInput').innerHTML = '';
    },
    setInit: () => {
      setDefaultValue();
      onChange([defaultValue,'']);
    }
  }));
  useEffect(()=>{
    document.addEventListener('selectionchange', (event) => {
      const sel = window.getSelection();
      const range = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
      //如果当前元素是我的富文本
      if (range && range.commonAncestorContainer.ownerDocument.activeElement.id === 'myInput') {
        savedRange = range;
      }
    });
    setDefaultValue();
  },[])

  useEffect(()=>{
    if(clickTag.key) {
      addTag(` ${clickTag.value} `);
    }
  },[clickTag])

  useEffect(() => {
    if(defaultValue) {
      setDefaultValue();
      onChange([defaultValue,templateId]);
      // 把光标位置移到最后
      // let selection = window.getSelection();
      // myInputRef.current?.focus();
      // selection?.selectAllChildren(myInputRef.current);
      // selection?.collapseToEnd(); //光标移至最后        
      // myInputRef.current.focus();
      // if (myInputRef.current.setSelectionRange) {
      //   // 将光标移动到输入框文本的末尾
      //   const len = myInputRef.current.value.length;
      //   myInputRef.current.setSelectionRange(len, len);
      // }
    }
  }, [smsTemplateCount]);
  return (
    <div id="myInput" ref={myInputRef} className={`${styles.tagTextArea}`} onKeyUp={onKeyUp} dangerouslySetInnerHTML = {{__html:`${initValue}`}} ></div>
  )
}
export default Text;
